import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./Hub.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'


const PromotersPage = ({ setIsLoading, isLoading, promotersPopup, setPromotersPopup, indEvent, setIndEvent, promoterLimits, setPromoterLimits, teamSearchTerm, setTeamSearchTerm, setTeamFocused }) => {
	const [validationError, setValidationError] = useState(null)


	useEffect(() => {
		if (validationError) {
		  	const timer = setTimeout(() => setValidationError(null), 5000);
		  	return () => clearTimeout(timer);
		}
	}, [validationError]);

	const handleClose = () => {
		setPromoterLimits({})
		setPromotersPopup(false)
	}

	const handleLimits = async (control, promoterId?) => {
	  	if (control === "-") {
			setPromoterLimits(prev => {
			  	const current = prev[promoterId] || 0;
			  	if (current === 0) return prev;
			  	return {
			    	...prev,
			    	[promoterId]: current - 1
			  	};
			});
	  	} else if (control === "+") {
	  		const currentPromoterLimits = (promoterLimits[promoterId] ? promoterLimits[promoterId]+1 : 1) || 1
	  		if ((indEvent.capacityOG !== false) && indEvent.capacity+(currentPromoterLimits) > indEvent.capacityOG) {
	  			await window.alert("This change puts you over the Guestii capacity limit you set!")
	  			return;
	  		}

			setPromoterLimits((prev) => ({
			  ...prev,
			  [promoterId]: (prev[promoterId] || 0) + 1
			}));
	  	} else {
	  		for (const promoter of promotersPopup) {
	  			if (!promoterLimits[promoter['value']]) {
	  				setValidationError(`Please choose a limit for ${promoter.first_name} ${promoter.last_name}`)
	  				return false;
	  			} else {
	  				if (promoterLimits[promoter['value']] === 0) {
		  				setValidationError(`Please choose a limit for ${promoter.first_name} ${promoter.last_name}`)
		  				return false;
	  				}
	  			}
	  		}

	  		setValidationError(null)
	  		setTeamSearchTerm([])
	  		setIsLoading(true)

	  		const userId = localStorage.getItem('_id');
	  		let newEvent;
	  		if (promotersPopup && promotersPopup.length > 0 && promotersPopup[0]['edit']) {
				newEvent = await axios.post(`/api/hub/update-promoter-limit/${userId}`, {
		      		event: indEvent._id,
		      		limits: promoterLimits
		    	});
	  		} else {
		    	newEvent = await axios.post(`/api/hub/invite-new-team/${userId}`, {
		      		event: indEvent._id,
		      		values: teamSearchTerm,
		      		limits: promoterLimits
		    	});
	  		}
	    	
	    	setIndEvent(newEvent.data.newEvent)
	    	setIsLoading(false)
	    	setTeamFocused(false)
	    	setPromotersPopup(false)
	  	}
	};

	return (
		<div className={`${styles.popup_container_ind_team}`}>
			{!isLoading
				?
					<div className={styles.promoters_layout}>
					    {(validationError && validationError.length > 0) &&
					        <div className={styles.error_banner_promoters}>
					          	<p className={styles.error_text}>{validationError}</p>
					        </div>
					    }

						<button className={styles.ind_close_ind} onClick={handleClose}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

						<div className={styles.new_banner}>
							<div className={styles.new_title}>
								<p className={styles.bold}>Set Promoter Limits</p>
								<p className={styles.s1}>Choose a list limit for each promoter</p>
							</div>

							<div className={styles.banner_progress}>
								<div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
									<i className={`fa-solid fa-envelope ${styles.m1}`}></i>
								</div>
							</div>
						</div>

						<div className={styles.promoters_form_container}>
							<div className={styles.ratings_warning}>
								<p className={styles.s1}>Limits are event specific. This only apply's for this event.</p>
							</div>

							<div
								style={{
									height: '100%',
									maxHeight: '100%',
									overflowY: 'scroll',
									position : 'relative',
								}}
							>
								<div className={`${styles.table_container_indguestii} table_container`} style={{ gridTemplateColumns: '1fr', gridTemplateRows: `max-content` }}>
									{promotersPopup.map((node, n) => {
										const lastItem = n === (promotersPopup.length - 1);

										return (
											<div className={`${styles.guestii_invited_ind} ${styles.guestii_invited_ind_black} ${lastItem && styles.paddingLastItem} ${styles.no_hover}`}>
												<div className={styles.guestii_inner_split}>
													<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

													<div className={styles.guestii_profile_info}>
														<p className={styles.s1}>{node.first_name} {node.last_name}</p>
														<p className={styles.xs2}>{node.email}</p>
													</div>
							                    </div>

									            <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
									                <label className={styles.xs3}>
									                  	Limit:
									                </label>

									                <div className={styles.customNumberInput}>
									                	<button
									                		className={`${styles.numberControl}`}
									                		onClick={() => handleLimits('-', node.value)}
									                	>
									                		<i className={`fa-solid fa-minus ${styles.xs2}`}></i>
									                	</button>

									                	<input
									                		type="number"
									                		disabled={true}
									                		value={promoterLimits[node.value] || 0}
									                		className={`${styles.s1}`}
									                	/>

									                	<button
									                		className={`${styles.numberControl}`}
									                		onClick={() => handleLimits('+', node.value)}
									                	>
									                		<i className={`fa-solid fa-plus ${styles.xs2}`}></i>
									                	</button>
									                </div>
									            </div>
							                </div>
							            )
							        })}
								</div>
							</div>
						</div>

						<div className={styles.control_container}>
							<button className={`${styles.control_btn} ${styles.next_btn} ${validationError && styles.validationBtn}`} disabled={validationError} onClick={() => handleLimits('submit')}>
								<i className={`fa-solid fa-check ${styles.m1}`}></i>
							</button>
						</div>
					</div>
				:
			        <div className={styles.loading_layout_promoter}>
			            <img src={guestii_gif}/>
			        </div>
			}
		</div>
	)
}


const Promoters = ({ promotersPopup, setPromotersPopup, indEvent, setIndEvent, promoterLimits, setPromoterLimits, teamSearchTerm, setTeamSearchTerm, setTeamFocused }) => {
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (promotersPopup && promotersPopup.length > 0 && promotersPopup[0]['edit']) {
			setPromotersPopup(prev => prev.map(({ _id, ...rest }) => ({ value: _id, ...rest })));

			setPromoterLimits({
				[promotersPopup[0]._id]: promotersPopup[0].limit
			})
		}
	}, [])

	return (
		<PromotersPage {... { setIsLoading, isLoading, promotersPopup, setPromotersPopup, indEvent, setIndEvent, promoterLimits, setPromoterLimits, teamSearchTerm, setTeamSearchTerm, setTeamFocused } }/>
	);
};

export default Promoters;